// Update Variant price start
function UpdateVariantPrice(){
     var TotalVariantValue = 0;
    $('.qty-input_bulk').each(function () {
        var currentVal = parseFloat($(this).val()) || 0;
        var currentPrice = parseFloat($(this).attr('data-price')) || 0;
        var currentSingleVariantTotal = $(this).closest('.single_variant_box').find('.bulk_cart_single_totle');
        var total = currentPrice * currentVal;
        currentSingleVariantTotal.text(total.toFixed(2));
         TotalVariantValue += currentVal;
    });
    //alert(TotalVariantValue);
    $('#total_bulk_items').text(TotalVariantValue);
    var totalProductPrice = 0;
    $('.bulk_cart_single_totle').each(function(){
        var currentItemTotal = parseFloat($(this).text()) || 0;
        totalProductPrice += currentItemTotal;
    });
    // alert(totalProductPrice);
    $('#total_product_bulk_price').text(totalProductPrice.toFixed(2));
    if(TotalVariantValue > 0){
       $('span.remove_all_variant_items').addClass('show');
    }else {
       $('span.remove_all_variant_items').removeClass('show');
    }
    
}
// Update Variant price end
// Single variant add to cart Start
$(document).on('click', '.qty-plus_bulk', function () {
  var qtyAvailableMessage = $(this).closest('.bulk-variant-cart__quantity_box').find('.stock_items_error');
  var mainCurrentQtyBox = $(this).closest('.bulk-variant-cart__quantity_box');
  var loader = mainCurrentQtyBox.find('.loading_bulk');
  mainCurrentQtyBox.addClass('disabled');

  var $input = $(this).prev('input');

  var currentQty = parseInt($input.val(), 10) || 0;
  var maxQty = parseInt($input.attr('max'), 10);
  var variantId = $(this).attr('data-variant-id');

  if (currentQty === 0) {
    $input.val(1).attr('value', 1);
    loader.show(); 
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: 1
      },
      dataType: 'json',
      success: function (response) {
        mainCurrentQtyBox.removeClass('disabled');
        UpdateVariantPrice();
        loader.hide();
        console.log(response);
      },
      error: function (error) {
        mainCurrentQtyBox.removeClass('disabled');
        UpdateVariantPrice();
        loader.hide();
        console.log(error);
      }
    });

  } else {
    if (currentQty < maxQty) {
      var currentQtyUpdate = currentQty + 1;
      $input.val(currentQtyUpdate).attr('value', currentQtyUpdate);
      loader.show();
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
          updates: {
            [variantId]: currentQtyUpdate
          }
        },
        dataType: 'json',
        success: function (cart) {
          mainCurrentQtyBox.removeClass('disabled');
          UpdateVariantPrice();
          loader.hide();
          console.log(cart);
        },
        error: function (err) {
          mainCurrentQtyBox.removeClass('disabled');
          UpdateVariantPrice();
          loader.hide();
          console.log(err);
        }
      });
    } else {
        // alert("clicked");
        qtyAvailableMessage.fadeIn();
        setTimeout(()=> {
        qtyAvailableMessage.fadeOut();
        },5000);
      mainCurrentQtyBox.removeClass('disabled');
    }
  }
});
// Single variant add to cart End


// Single variant item update start
$(document).on('click', '.qty-minus_bulk', function () {
  var mainCurrentQtyBox = $(this).closest('.bulk-variant-cart__quantity_box');
  mainCurrentQtyBox.addClass('disabled');
  var loader = mainCurrentQtyBox.find('.loading_bulk');
  var $input = $(this).next('input');

  var currentQty = parseInt($input.val(), 10) || 0;
  var minQty = parseInt($input.attr('min'), 10);
  var variantId = $(this).attr('data-variant-id');

  if (currentQty > minQty) {
    loader.show();
    var currentQtyUpdate = currentQty - 1;
    $input.val(currentQtyUpdate).attr('value', currentQtyUpdate);

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: {
        updates: {
          [variantId]: currentQtyUpdate
        }
      },
      dataType: 'json',
      success: function (cart) {
        mainCurrentQtyBox.removeClass('disabled');
        UpdateVariantPrice();
        loader.hide();
        console.log(cart);
      },
      error: function (err) {
        mainCurrentQtyBox.removeClass('disabled');
        UpdateVariantPrice();
        console.log(err);
      }
    });
  } else {
    mainCurrentQtyBox.removeClass('disabled');
  }
});
// Single variant item update End


// Manual input change start
$(document).on('change', '.qty-input_bulk', function () {
  var qtyAvailableMessage = $(this).closest('.bulk-variant-cart__quantity_box').find('.stock_items_error');
  var mainCurrentQtyBox = $(this).closest('.bulk-variant-cart__quantity_box');
  
  mainCurrentQtyBox.addClass('disabled');
  var loader = mainCurrentQtyBox.find('.loading_bulk');

  var min = parseInt($(this).attr('min'), 10) || 0;
  var max = parseInt($(this).attr('max'), 10) || 0;
  var val = parseInt($(this).val(), 10) || 0;

  if (val > max) {
    loader.show();
    qtyAvailableMessage.fadeIn();
        setTimeout(()=> {
        qtyAvailableMessage.fadeOut();
        },5000);
    val = max;
  } else if (val < min) {
    loader.hide();
    val = min;
  }

  $(this).val(val).attr('value', val);

  var variantId = $(this).attr('data-variant-id');

  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: {
      updates: {
        [variantId]: val
      }
    },
    dataType: 'json',
    success: function (cart) {
      mainCurrentQtyBox.removeClass('disabled');
      UpdateVariantPrice();
      console.log(cart);
      loader.hide();
    },
    error: function (err) {
      mainCurrentQtyBox.removeClass('disabled');
      UpdateVariantPrice();
      console.log(err);
    }
  });
});
// Manual input change End

// Show hide single variant remove button start 
setInterval(() => {
    $('.qty-input_bulk').each(function () {
        var currentVal = parseFloat($(this).val()) || 0;
        var getCurrentDelBtn = $(this).closest('.bulk-variant-cart__quantity_box').find('.single_varint_del');
        if (currentVal == 0) {
            getCurrentDelBtn.hide();
        } else {
            getCurrentDelBtn.show();
        }
        });
}, 1000);
// Show hide single variant remove button end

// Remove single variant start

$(document).on('click', '.single_varint_del', function(){
     var getCurrentInput = $(this).closest('.bulk-variant-cart__quantity_box').find('.qty-input_bulk');
     var loader = $(this).closest('.bulk-variant-cart__quantity_box').find('.loading_bulk');
     getCurrentInput.val(0).attr('value', 0).trigger('change');
     loader.show();
});

// Remove single variant end

// Update current variant item added in cart start
function UpdateCurrentaddedVariant(){
   fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
        cart.items.forEach((item, i) => {
        // console.log(`Item ${i + 1}`);
        // console.log('Variant ID:', item.variant_id);
        // console.log('Quantity:', item.quantity);

        $('.qty-input_bulk').each(function () {
            var singleVarinat = $(this).attr('data-variant-id');

            if (singleVarinat == item.variant_id) {
            $(this).val(item.quantity).attr('value', item.quantity);
            }
        });
        });
    });
}
UpdateCurrentaddedVariant();
setTimeout(() => {
    UpdateVariantPrice();
}, 2000);

// Update current variant item added in cart end

// Remove all items start
$(document).on('click', '.remove_all_variant_items', function () {
  var loader = $(this).find('.loading_bulk');
  var itemsToRemove = {};

  $('.qty-input_bulk').each(function () {
    var variantId = $(this).data('variant-id');
    var qty = parseInt($(this).val(), 10) || 0;

    if (qty > 0) {
      itemsToRemove[variantId] = 0; // set qty 0 = remove
      loader.show();
    }
  });

  // If nothing to remove
  if ($.isEmptyObject(itemsToRemove)) {
    console.log('No items to remove');
    return;
  }

  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: {
      updates: itemsToRemove
    },
    dataType: 'json',
    success: function (cart) {
      console.log('All items removed', cart);
      // location.reload(); 
      loader.hide();
      $('.qty-input_bulk').val(0).attr('value', 0).trigger('change');
      
    },
    error: function (err) {
      console.log('Error removing items', err);
    }
  });

});

// Remove all items end